export class ContactData {
  constructor(public message: string) {
  }
}

export class ContactFormData {
  constructor(public firstName: String, public lastName: String, public email: String, public phone: String, public pollNumbers: String, public organization: String, public message: String) {
  }
}
